import styled from 'styled-components';
import { Text12ExtraBold, Text14Light } from '../../utils/Text/Text.styles';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  background: #fff;
  padding: 1.2rem;
  gap: 0.9rem;
  width: calc(50% - 8px);

  @media only screen and (max-width: 700px) {
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.9rem;
`;

export const DescriptionText = styled(Text14Light)`
  line-height: 23px;
  letter-spacing: -0.408px;
`;

export const Button = styled.button`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: -0.42px;
  color: #fff;
  padding: 0.8rem 2.4rem;
  cursor: pointer;
`;

export const OptionalText = styled(Text12ExtraBold)`
  opacity: 0.2;
`;
